import axios from "axios";
import { FSServerID, FSServerIP, LLServerID, LLServerIP, TSServerID, TSServerIP } from './Server';
import { decodeWithBase64, encodeStringToBase64, encodeWithBase64 } from "./encodedecode";
import { saveData } from "./Data";
import { LanguageStore } from "./LanguageStore";

export const loginWithGoogle = async (formData) => {
    let serverip = LLServerIP;
    return axios({
        method: 'post',
        url: serverip + 'googleLogin',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const FetchForumDetails = async (ForumDetails) => {
    try {
        ForumDetails['ServerID'] = TSServerID;
        return axios({
            method: "post",
            url: TSServerIP + 'getSelectedForumTemplateDataToUpdateTemplate',
            data: ForumDetails,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });
    } catch (e) { }
}

export const generateReport = async (payload, api) => {
    try {
        // ForumDetails['ServerID'] = TSServerID;
        return axios({
            method: "post",
            url: FSServerIP + api,
            data: payload,
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });
    } catch (e) { }
}

export const SendingBridgeUpdate = async (payload, api) => {
    try {
        return axios({
            method: "post",
            url: FSServerIP + api,
            data: payload,
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });
    } catch (e) { }
}

export const getSingleForumData = async (forumJson) => {
    try {
        forumJson['ServerID'] = FSServerID;
        return axios({
            method: 'post',
            url: FSServerIP + 'getSingleForumDetails',
            data: forumJson,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });
    } catch (e) { }
}

export const addingAdminExternally = async (adminJson) => {
    try {
        adminJson['ServerID'] = FSServerID;
        return axios({
            method: "post",
            url: FSServerIP + 'addingAdminAfterAcceptance',
            data: adminJson,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });
    } catch (e) { }
}

export const getUserDetailsUsingNumber = async (ForumId, Admins, Users) => {
    try {
        const userProfile = JSON.parse(decodeWithBase64(localStorage.getItem("userProfile")));
        const tempJson = {
            "ForumID": ForumId,
            "Admins": Admins,
            "Users": Users,
            "SessionID": userProfile["SessionID"],
            "MACAddress": userProfile["MACAddress"],
            "ServerID": FSServerID
        }
        return axios({
            method: "post",
            url: FSServerIP + 'getUserDetailsUsingNumber',
            data: tempJson,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });
    } catch (e) {

    }
}

export const UpdateBridge = async (payload) => {
    try {
        return axios({
            method: "post",
            url: FSServerIP + 'updateForumBridge',
            data: payload,
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });
    } catch (e) { }
}

export const DeleteBridge = async (deleteJson) => {
    try {
        return axios({
            method: "post",
            url: FSServerIP + 'deleteForumBridge',
            data: deleteJson,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });
    } catch (e) {

    }
}

export const LogoutFromSystem = async () => {
    try {
        const userProfile = JSON.parse(decodeWithBase64(localStorage.getItem("userProfile")));
        let logoutJson = {
            "SessionID": userProfile["SessionID"],
            "MACAddress": userProfile['MACAddress'],
            "ServerID": LLServerID,
            "MobileNumber": userProfile['MobileNumber'],
        }
        localStorage.clear();
        sessionStorage.clear();
        return axios({
            method: 'post',
            url: LLServerIP + 'logOutMachine',
            data: logoutJson,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });
    } catch (e) { }
}

export const getMediaData = async (mediaData) => {
    try {
        return axios({
            method: "post",
            url: FSServerIP + 'getSelectedForumMedia',
            data: mediaData,
            headers: { 'Content-Type': 'application/image' },
            responseType: 'blob',
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });
    } catch (e) { }
}

export const addUserToForum = async (userJson) => {
    try {
        return axios({
            method: "post",
            url: FSServerIP + 'addingForumUsersExternally',
            data: userJson,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });
    } catch (e) {

    }
}

export const ClientSync = async () => {
    try {
        let userProfile = localStorage.getItem("userProfile");
        if (!userProfile) return null;
        userProfile = JSON.parse(decodeWithBase64(userProfile));
        const clientSyncJson = {
            "MACAddress": userProfile["MACAddress"],
            "SessionID": userProfile["SessionID"],
            "ServerID": FSServerID,
        }
        return axios({
            method: "post",
            url: FSServerIP + 'clientSync',
            data: clientSyncJson,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });

    } catch (e) {

    }
}

export const checkSSID = async (tempJson) => {
    try {
        return axios({
            method: "get",
            url: LLServerIP + 'CheckSSID',
            data: tempJson,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });
    } catch (error) {
        return null;
    }
}

export const userSubscriptionDetails = async (key) => {
    try {
        const userProfile = JSON.parse(decodeWithBase64(localStorage.getItem("userProfile")));
        const tempJson = {
            "MACAddress": userProfile["MACAddress"],
            "SessionID": userProfile["SessionID"],
            "ServerID": LLServerID,
            "InfoKey": key
        };
        return axios({
            method: 'post',
            url: LLServerIP + 'userSubscriptionDetails',
            data: tempJson,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });

    } catch (error) {
        return null;
    }
}

export const paymentInformation = async () => {
    try {
        const userProfile = JSON.parse(decodeWithBase64(localStorage.getItem("userProfile")));
        const tempJson = {
            "MACAddress": userProfile["MACAddress"],
            "SessionID": userProfile["SessionID"],
            "ServerID": LLServerID,
        };
        return axios({
            method: 'post',
            url: LLServerIP + 'paymentInformation',
            data: tempJson,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });
    } catch (error) {
        return error;
    }
}
export const paymentOrder = async (data, userType = "Pro") => {
    try {
        const userProfile = JSON.parse(decodeWithBase64(localStorage.getItem("userProfile")));
        const tempJson = {
            "MACAddress": userProfile["MACAddress"],
            "SessionID": userProfile["SessionID"],
            "ServerID": LLServerID,
            "UserType": userType,
            "Country": data
        };
        return axios({
            method: 'post',
            url: LLServerIP + 'paymentOrder',
            data: tempJson,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });
    } catch (error) {
        return error;
    }
}
export const paymentVerification = async (data) => {
    try {
        const userProfile = JSON.parse(decodeWithBase64(localStorage.getItem("userProfile")));
        const tempJson = {
            "MACAddress": userProfile["MACAddress"],
            "SessionID": userProfile["SessionID"],
            "ServerID": LLServerID,
            "order_id": data['order_id'],
            "payment_id": data['payment_id'],
            "signature": data['signature']
        };
        return axios({
            method: 'post',
            url: LLServerIP + 'paymentVerification',
            data: tempJson,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });
    } catch (error) {
        return error;
    }
}

export const topUpsOrder = async (data) => {
    try {
        const userProfile = JSON.parse(decodeWithBase64(localStorage.getItem("userProfile")));
        const tempJson = {
            "MACAddress": userProfile["MACAddress"],
            "SessionID": userProfile["SessionID"],
            "ServerID": LLServerID,
            "UserType": "Pro",
            "Country": data.Country,
            "TopupType": data.TopupType,
            "RequestedLimit": data.RequestedLimit
        };
        return axios({
            method: 'post',
            url: LLServerIP + 'topUpsOrder',
            data: tempJson,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });
    } catch (error) {

    }
}

export const topUpVerification = async (data) => {
    try {
        const userProfile = JSON.parse(decodeWithBase64(localStorage.getItem("userProfile")));
        const tempJson = {
            "MACAddress": userProfile["MACAddress"],
            "SessionID": userProfile["SessionID"],
            "ServerID": LLServerID,
            "order_id": data['order_id'],
            "payment_id": data['payment_id'],
            "signature": data['signature'],
            "TopupType": data['TopupType'],
            "Country": data['Country'],
        };
        return axios({
            method: 'post',
            url: LLServerIP + 'topUpVerification',
            data: tempJson,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });
    } catch (error) {
        console.error(error);
    }
}

export const getBridgeLanguages = async () => {
    try {
        const langJson = {
            ServerID: FSServerID,
        }

        const resp = await axios({
            method: 'post',
            url: FSServerIP + 'getBridgeLanguages',
            data: langJson,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });

        return resp;
    } catch (error) {
        console.error("Error fetching bridge language strings:", error);
    }
}

export const fetchBridgeLanguageStrings = async (selectedLanguage) => {
    try {
        const userProfile = JSON.parse(decodeWithBase64(localStorage.getItem("userProfile")));
        const languageJson = {
            SelectedLanguage: selectedLanguage,
            SessionID: userProfile["SessionID"],
            MACAddress: userProfile["MACAddress"],
            ServerID: FSServerID,
        }
        const resp = await axios({
            method: 'post',
            url: FSServerIP + 'getSelectedBridgeLanguageMeta',
            data: languageJson,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });
        const data = resp;
        if (Object.keys(data).length > 0) {
            saveData("bridgeLanguageStrings", encodeStringToBase64(JSON.stringify(data)));
            localStorage.setItem('BridgeLanguageStrings', encodeStringToBase64(JSON.stringify(data)));
            LanguageStore.allLanguages = data;
        }
        return data;
    } catch (error) {
        console.error("Error fetching bridge language strings:", error);
    }
}

export const addingForumAdminsExternally = async (adminJSON) => {
    try {
        const userProfile = JSON.parse(decodeWithBase64(localStorage.getItem("userProfile")));
        let adminJson = {
            "ForumID": adminJSON.ForumID,
            "MACAddress": userProfile['MACAddress'],
            "SessionID": userProfile['SessionID'],
            "AddAdminsToForum": adminJSON.AddAdminsToForum,
            "Creator": adminJSON.Creator,
            "Modifier": adminJSON.Modifier,
            "Approver": adminJSON.Approver,
            "Priority": adminJSON.Priority,
            "Forum": true,
            "ChatForum": false,
            "Owner": userProfile["UserName"],
            "UnBlockUsers": false,
            "ServerID": FSServerID
        };
        return axios({
            method: 'post',
            url: FSServerIP + 'addingForumAdminsExternally',
            data: adminJson,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return error;
            });
    } catch (error) {
        console.error(error);
    }
}